import React from 'react';
import {
  PlannerPage,
  PlannerCard,
  PlannerKicker,
  PlannerHeading,
  PlannerSubtle,
} from './plannerTheme';

export default function ChurchPlannerSupportPage() {
  return (
    <PlannerPage>
      <PlannerCard>
        <PlannerKicker>Help</PlannerKicker>
        <PlannerHeading>Support</PlannerHeading>
        <PlannerSubtle>
          Contact your church administrator for access issues or planning workflow help.
        </PlannerSubtle>
      </PlannerCard>
    </PlannerPage>
  );
}
